// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Cairo_e0906e', '__Cairo_Fallback_e0906e'","fontStyle":"normal"},"className":"__className_e0906e","variable":"__variable_e0906e"};